import React from 'react';
import API from '../../service/SiteKickAPIService';

const ImageResize = (props) => {
    const src = props.src;
    let url = src;

    if (src.substring(0, 4) === "http") {
        try {
            let bucket = props.bucket || src.split("//")[1].split(".s3")[0];
            let key = props.key || src.split("//")[1].split(".com/")[1].split('?')[0];
            let w = props.width;
            let h = props.height;
            let perc = props.resize_perc !== undefined ? props.resize_perc : props.width === undefined ? 0.5 : null;

            let query_string = perc ? "resize_perc=" + perc : "width=" + w + "&height=" + h;
            url = API.getFullUrl("/image-resource?" + query_string + "&bucket=" + bucket + "&key=" + key)
        } catch (e) {
            console.log(e);
        }
    }

    return <img original_src={src} {...props} src={url} alt={props.alt || ''} />
}

export default ImageResize;